// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7e61740","453":"7a0127ce","732":"a41e6bf8","977":"e0eb0b2a"}[chunkId] + ".chunk.js";
};